import $ from 'jquery'
import Swiper from 'swiper'

export default () => {
  $(() => {
    if (!$('.component-posts .posts.swiper-container').length) return

    new Swiper('.component-posts .posts.swiper-container', {
      loop: true,
      slidesPerView: window.WP_VAR.slidesPerViewMobile,
      spaceBetween: 16,
      navigation: {
        nextEl: '.swiper-button-next',
        prevEl: '.swiper-button-prev'
      },
      breakpoints: {
        768: {
          slidesPerView: window.WP_VAR.slidesPerViewDesktop
        }
      }
    })
  })
}
